import React from 'react';
import { Route, Routes } from 'react-router-dom';

import AppNavigate from './components/reusable/app-navigate/AppNavigate';
import NotFoundPage from './components/reusable/error-pages/NotFoundPage/NotFoundPage';
import { useFeature } from './hooks/use-feature';
import BugReportRouter from './pages/bug-reports/BugReport.router';
import Contacts from './pages/contacts/Contacts';
import ExercisesRouter from './pages/exercises/Exercises.router';
import Notifications from './pages/notifications/Notifications';
import ProgramsRouter from './pages/programs/Programs.router';
import Resources from './pages/resources/Resources';
import SocialRouter from './pages/social/Social.router';
import News from './pages/social/news/News';
import StatisticsRouter from './pages/statistics/Statistics.router';
import TrainingsRouter from './pages/trainings/Trainings.router';
import UsersRouter from './pages/users/Users.router';
import Home from './pages/users/home/Home';
import Settings from './pages/users/settings/Settings';
import UserPlanRoute from './pages/users/user-plan/UserPlanRoute';
import { AppFeatureKey } from './shared/constants';
// import Chats from "./pages/chats/chats/Chats";
// import Chat from "./pages/chats/chat/Chat";
import { Paths } from './shared/paths';

const AppLoggedInRoutes = () => {
  const { [AppFeatureKey.resourses]: resoursesFeatureActive } = useFeature();

  return (
    <Routes>
      {/*todo Create separate user(social) route*/}
      <Route path={`${Paths.users.root}/*`} element={<UsersRouter />} />
      <Route path={Paths.users.me} element={<Home />} />
      <Route path={`${Paths.communities.root}/*`} element={<SocialRouter />} />
      <Route path={Paths.news.root} element={<News />} />
      <Route path={Paths.inAppNotifications.root} element={<Notifications />} />
      {/*<Route path={Paths.chats} element={authChecking(<Chats/>)}/>*/}
      {/*<Route path={`${Paths.chats}/:chatId`} element={authChecking(<Chat/>)}/>*/}
      <Route path={`${Paths.exercises.root}/*`} element={<ExercisesRouter />} />
      <Route path={`${Paths.programs.root}/*`} element={<ProgramsRouter />} />
      <Route path={`${Paths.trainings.root}/*`} element={<TrainingsRouter />} />
      <Route
        path={`${Paths.statistics.root}/*`}
        element={<StatisticsRouter />}
      />
      <Route path={Paths.plan.root} element={<UserPlanRoute />} />
      <Route
        path={`${Paths.bugReports.root}/*`}
        element={<BugReportRouter />}
      />
      <Route path={`${Paths.settings.root}/*`} element={<Settings />} />
      <Route path={Paths.contacts} element={<Contacts />} />
      {resoursesFeatureActive && (
        <Route path={Paths.resources} element={<Resources />} />
      )}
      <Route
        path={Paths.root}
        element={<AppNavigate to={Paths.trainings.root} replace />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppLoggedInRoutes;
